export const getRoleName = (name) => {
  if (name == "superadmin") return "Super Admin";
  if (name == "radiologist") return "Radiologist";
  if (name == "subadmin") return "Sub Admin";
  if (name == "siteperson") return "Site Person";
  if (name == "qualitychecker") return "Quality Checker";
};
